export default "./dist/stdassets/images/icons/control-180.png";